/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';

import shuffle from 'lodash/shuffle';
import * as AppPropTypes from '../../lib/PropTypes';
import useOrganisationMembers from '../../hooks/useOrganisationMembers';
import Avatar from './Avatar';

import styles from '../../../styles/partials/team-members.module.scss';

const propTypes = {
    organisation: AppPropTypes.organisation,
    withoutAdd: PropTypes.bool,
    maxCount: PropTypes.number,
    random: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    organisation: [],
    withoutAdd: false,
    maxCount: 3,
    random: false,
    className: null,
};

const TeamMembers = ({ organisation, withoutAdd, maxCount, random, className }) => {
    const url = useUrlGenerator();
    const { members = [] } = useOrganisationMembers(organisation.id);
    const partialMembers = members || [];

    const validMembers = useMemo(() => {
        const items = (partialMembers || []).filter(
            ({ invitation, user: memberUser }) => memberUser && !invitation,
        );
        return items;
    }, [partialMembers.length, random]);

    const filteredMembers = useMemo(() => {
        const items = (validMembers || [])
            .filter(({ invitation, user: memberUser }) => memberUser && !invitation)
            .filter((member, i) => i < maxCount);
        return random ? shuffle(items) : items;
    }, [validMembers.length, random]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                {filteredMembers.map(({ user: memberUser }, i) => (
                    // eslint-disable-next-line react/jsx-indent
                    <Avatar
                        key={`member-${memberUser}-${i + 1}`}
                        className={styles.item}
                        {...memberUser}
                    />
                ))}
                {(members || []).length > maxCount ? (
                    <Avatar
                        className={classNames([styles.item, styles.dots])}
                        key="author-more"
                        color={{ color: '#fff' }}
                        short_name={`+${validMembers.length - maxCount}`}
                    />
                ) : null}
                {!withoutAdd ? (
                    <Button
                        href={url('organisations.team')}
                        className={classNames(['btn', 'btn-primary', styles.item, styles.plus])}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

TeamMembers.propTypes = propTypes;
TeamMembers.defaultProps = defaultProps;

export default TeamMembers;
